module.exports = __webpack_public_path__ + "img/contTitle_alim.77cc99f7.svg";